"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";
import {
     lookupTableListComplete,
     ajaxError,
     lookupTableTypesComplete,
     lookupTableAddComplete,
     lookupTableDeleteComplete,
     lookupTableGetComplete,
     lookupTableUpdateComplete,
     lookupTableActiveInactiveComplete,
     lookupTableListRequest,
     lookupTableValueAddComplete,
     lookupTableValueDeleteComplete,
     lookupTableValueGetComplete,
     lookupTableValueUpdateComplete,
     lookupTableValueListComplete,
     lookupTableValueListRequest,
     lookupTableLabelsComplete,
     lookupTableCSVFileUploadComplete,
     lookupTableSingleCSVFileUploadComplete,
} from "../_actions";
import {
     authConstants,
     requestTypes,
     lookupTableConstants,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const lookupTableAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_ADD_REQUEST),
          mergeMap((action) => {
               const { navigate, ...payload } = action.payload;

               if (!payload.active) {
                    payload.active = false;
               }
               return ajax
                    .post(
                         "/api/lookupTable/add",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              navigate("/app/lookup-data-manage");
                              return lookupTableAddComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableListEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/lookupTable/search",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              lookupTableListComplete(ajaxResponse.response),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableSearchEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_SEARCH_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/lookupTable/search",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              lookupTableListComplete(ajaxResponse.response),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_TYPES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/lookupTable/types",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return lookupTableTypesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupLabelsTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_LABELS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/lookupTable/labels",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return lookupTableLabelsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_DELETE_REQUEST),
          mergeMap((action) => {
               const { page, pageSize, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/delete",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   lookupTableDeleteComplete(
                                        ajaxResponse.response,
                                   ),
                                   lookupTableListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_GET_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/lookupTable/get",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return lookupTableGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_UPDATE_REQUEST),
          mergeMap((action) => {
               const { navigate, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/edit",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              navigate("/app/lookup-data-manage");
                              return lookupTableUpdateComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableActiveInactiveEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_ACTIVE_INACTIVE_REQUEST),
          mergeMap((action) => {
               const { page, pageSize, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/activeInactive",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   lookupTableActiveInactiveComplete(
                                        ajaxResponse.response,
                                   ),
                                   lookupTableListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                              ),
                         ),

                         catchError((error) => {
                              return of(
                                   lookupTableListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                                   ajaxError(error),
                              );
                         }),
                    );
          }),
     );
};

export const lookupTableValueAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_VALUE_ADD_REQUEST),
          mergeMap((action) => {
               const { closeFormModal, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/tableValueAdd",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              closeFormModal();
                              return of(
                                   lookupTableValueAddComplete(
                                        ajaxResponse.response,
                                   ),
                                   lookupTableValueListRequest({
                                        page: action.payload.page,
                                        pageSize: action.payload.rowsPerPage,
                                        lookupTableId: action.payload.lookupTableId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableValueListEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_VALUE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/lookupTable/tableValuelist",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              lookupTableValueListComplete(
                                   ajaxResponse.response,
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableValueDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_VALUE_DELETE_REQUEST),
          mergeMap((action) => {
               const { lookupTableId, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/tableValueDelete",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   lookupTableValueDeleteComplete(
                                        ajaxResponse.response,
                                   ),
                                   lookupTableValueListRequest({
                                        page: payload?.page,
                                        pageSize: payload?.pageSize,
                                        lookupTableId,
                                        search: payload?.search,
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableValueGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_VALUE_GET_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/lookupTable/tableValueGet",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return lookupTableValueGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTableValueEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_VALUE_UPDATE_REQUEST),
          mergeMap((action) => {
               const { closeFormModal, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/tableValueUpdate",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              closeFormModal();
                              return of(
                                   lookupTableValueUpdateComplete(
                                        ajaxResponse.response,
                                   ),
                                   lookupTableValueListRequest({
                                        page: action.payload.page,
                                        pageSize: action.payload.rowsPerPage,
                                        lookupTableId: action.payload.lookupTableId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTablesCSVFileUploadEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_CSV_FILE_UPLOAD_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/csvFIleUpload",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return lookupTableCSVFileUploadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const lookupTablesSingleCSVFileUploadEpic = (actions$) => {
     return actions$.pipe(
          ofType(lookupTableConstants.LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/lookupTable/singleCsvFileUpload",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return lookupTableSingleCSVFileUploadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};
